import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import "firebase/compat/storage";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
// Initialize Firebase
var config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
};

const firebaseApp = firebase.initializeApp(config);

if (process.env.NODE_ENV === "development") {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = "809ca6d7-a15c-48bc-8d2b-ff938eecc985";
}

initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaEnterpriseProvider(
    process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  ),
  isTokenAutoRefreshEnabled: true,
});

const db = firebase.firestore();
const storage = firebase.storage();
const functions = firebase.functions();

export { firebase, storage, functions, db };
export default db;
